import React, { useRef, useState } from "react";
import PropTypes from "prop-types";
import HrnbLink from "./HrnbLink";
import HrnbButton from "./HrnbButton";
import HrnbNavbarPopup from "./HrnbNavbarPopup";
import {HamburgerIcon} from '../../icons';
import "../../css/components/controls/HrnbHamburger.css";

export default function HrnbHamburgerNav({ links = [], dropdowns = [], logo, user, onLogout, onLogin, extra, userMenuExtraItems = [] }) {
    const [open, setOpen] = useState(false);
    const [expandedDropdown, setExpandedDropdown] = useState(null);
    const btnRef = useRef(null);

    // Преобразуем обычные ссылки
    const items = links.map((l) => ({
        key: l.to || l.label,
        label: l.label,
        to: l.to,
        icon: l.icon,
        onClick: l.onClick,
    }));

    // Добавляем dropdown как элементы с подменю
    const dropdownItems = dropdowns.map((d, index) => ({
        key: `dropdown-${index}`,
        label: d.label,
        icon: d.icon,
        isDropdown: true,
        items: d.items || []
    }));

    // Админские пункты в меню пользователя
    const extraUserItems = userMenuExtraItems.map((item) => ({
        key: item.to || item.label,
        label: item.label,
        to: item.to,
        icon: item.icon,
    }));

    const allItems = [...items, ...dropdownItems, ...extraUserItems];

    const renderLogo = () => {
        if (!logo) return null;
        // if logo already a link (has `to` or `href`) — render as is
        if (React.isValidElement(logo) && (logo.props?.to || logo.props?.href)) return logo;
        return (
            <HrnbLink to="/" aria-label="На главную" className="hrnb-logo-link">
                <HrnbButton variant="ghost" aria-hidden="true" style={{ padding: 0 }}>
                    {logo}
                </HrnbButton>
            </HrnbLink>
        );
    };
    console.log(user)

    return (
        <nav className="hrnb-hamburger-nav" aria-label="Основная навигация">
            <div className="hrnb-hamburger__inner">
                <div className="hrnb-hamburger__left">{renderLogo()}</div>

                {user && (
                    <HrnbLink to="/cabinet" className="hrnb-mobile-user mobile-only">
                        {user.username || user.displayName || 'Пользователь'}
                    </HrnbLink>
                )}

                <div className="hrnb-hamburger__right">
                    {extra && <div className="hrnb-hamburger__extra">{extra}</div>}
                    <HrnbButton
                        ref={btnRef}
                        className={`hrnb-hamburger-btn ${open ? "is-open" : ""}`}
                        aria-label={open ? "Закрыть меню" : "Открыть меню"}
                        aria-expanded={open}
                        aria-controls="hrnb-hamburger-panel"
                        onClick={() => setOpen((s) => !s)}
                        type="button"
                        icon={<HamburgerIcon className={`hrnb-hamburger-icon ${open ? "is-open" : ""}`} />}
                    />
                </div>
            </div>

            <HrnbNavbarPopup
                anchorRef={btnRef}
                isOpen={open}
                onClose={() => setOpen(false)}
                items={allItems}
                user={user}
                onLogout={onLogout}
                onLogin={onLogin}
                align="right"
                dropdowns={dropdowns}
                expandedDropdown={expandedDropdown}
                onExpandDropdown={setExpandedDropdown}
            />
        </nav>
    );
}

HrnbHamburgerNav.propTypes = {
    links: PropTypes.array,
    logo: PropTypes.node,
    user: PropTypes.object,
    onLogout: PropTypes.func,
    onLogin: PropTypes.func,
};
